import { createStore } from '@/utils/createStore'

/**
 * Local row shape for the Meter Reading module.
 *
 * Uses STRING dates (YYYY-MM-DD) and a STRING status instead of the
 * Date-based `MeterReading` interface from `@/types`, so records round-trip
 * cleanly through JSON / localStorage without manual Date parsing.
 */
export interface MeterReadingRow {
  id: string
  type: 'generator' | 'consumer'
  entityId: string
  entityName?: string
  // ── Plant (a generator can have multiple plants — which one this reading is for) ──
  plantId?: string
  plantName?: string
  startDate: string            // YYYY-MM-DD
  endDate: string              // YYYY-MM-DD
  slots: { slotName: string; units: number }[]
  totalUnits: number
  status: string               // 'Draft' | 'Submitted' | 'Under Review' | 'Approved' | 'Rejected'
  submittedBy: string
  submittedAt: string          // YYYY-MM-DD
  approvedBy?: string
  approvedAt?: string          // YYYY-MM-DD
  rejectionReason?: string
  createdAt?: string
  updatedAt?: string
}

/* First 3 records from the original MOCK_READINGS, with Date fields converted
   to YYYY-MM-DD strings and the status enum flattened to its string value.
   Entity references are aligned to canonical masters (G001/G002, C001). */
export const meterReadingStore = createStore<MeterReadingRow>('sp_meter_readings', [], 'MR', 3, '/meter-readings')
